import React, { Component } from 'react';
import { PrimaryFormNav } from '../../components/PrimaryFormNav';
import { TextInput } from '../../components/BasicForm';
import { RadioMultiButton } from '../../components/RadioMultiButton';
import { DateField } from '../../components/DateField';

class MinorInfo extends Component {
	state = {
		heading: "Minor's Visitor Information",
		showProgressBar: true,
		pageId: 'minor-information',
	}
	componentWillMount() {
		const stepData = this.props.stepData;
		if(!stepData.access) {
			this.props.previousStep(stepData);
		}
		this.props.setHeaderDisplay(
			this.state.heading,
      		stepData.displayStep,
			this.state.showProgressBar,
			this.state.pageId,
      		stepData.step
		);
	}
	componentDidMount() {
		document.getElementById('root').scrollIntoView();
		window.scrollBy(0, -10);
	}
	handlePrevious = () => {
		const stepData = this.props.stepData;
		this.props.previousStep(stepData)
	}
	handleSubmit = (fields) => {
		const isErr = this.props.validateStep(fields);   
	    const stepData = this.props.stepData;
	    
	    if(!isErr) {
	    	this.props.nextStep(stepData);
	    } else {
	    	this.scrollToError()
	    }
	}
	scrollToError = () => {
		const fields = this.props.fields;
		let errFields = [];
		Object.keys(fields).map((fieldName) => {
			if(fields[fieldName].className === "input-err") {
				errFields.push(fieldName);
			}
			return fieldName;
		})
		const firstErr = document.querySelectorAll(`[name="${errFields[0]}"]`)[0];
		firstErr.scrollIntoView();
	}
	render() {
		const fields = this.props.fields;

		return(
			<form 
				className="visitation-form col-19"
				onSubmit={(e) => {this.handleSubmit(Object.keys(fields))}} >
				<legend className="required">* Required Information</legend>
				<fieldset className="dob">
					<DateField
						value={fields.DOB.value}
						handleDateInput={this.props.handleDateInput}
						name="DOB"
						required={fields.DOB.isRequired}
						className={fields.DOB.className}
						formatDate={this.props.formatDate}
						parseDate={this.props.parseDate}
						errMessage={fields.DOB.errMessage}
						label={fields.DOB.label} />
				</fieldset>
				<TextInput 
					label={fields.firstName.label}
		            className={fields.firstName.className}
		            value={fields.firstName.value}
		            name="firstName"
		            maxLength={fields.firstName.maxLength}
		            required={fields.firstName.isRequired}
		            placeholder={fields.firstName.placeholder}
		            errMessage={fields.firstName.errMessage}
		            onChange={this.props.handleInputChange}
		            id="firstName" /> 
		        <TextInput 
					label={fields.middleName.label}
		            className={fields.middleName.className}
		            value={fields.middleName.value}
		            name="middleName"
		            maxLength={fields.middleName.maxLength}
		            required={fields.middleName.isRequired}
		            placeholder={fields.middleName.placeholder}
		            errMessage={fields.middleName.errMessage}
		            onChange={this.props.handleInputChange}
		            id="middleName" />
		        <TextInput 
					label={fields.lastName.label}
		            className={fields.lastName.className}
		            value={fields.lastName.value}
		            maxLength={fields.lastName.maxLength}
		            name="lastName"
		            required={fields.lastName.isRequired}
		            placeholder={fields.lastName.placeholder}
		            errMessage={fields.lastName.errMessage}
		            onChange={this.props.handleInputChange}
		            id="lastName" />
		        <TextInput 
					label={fields.ssn.label}
		            className={fields.ssn.className}
		            value={fields.ssn.value}
		            name="ssn"
		            required={fields.ssn.isRequired}
		            placeholder={fields.ssn.placeholder}
		            maxLength={fields.ssn.maxLength}
		            errMessage={fields.ssn.errMessage}
		            onChange={this.props.handleInputChange}
		            id="ssn" />
		        <TextInput 
					label={fields.placeOfBirth.label}
		            className={fields.placeOfBirth.className}
		            value={fields.placeOfBirth.value}
		            name="placeOfBirth"
		            maxLength={fields.placeOfBirth.maxLength}
		            required={fields.placeOfBirth.isRequired}
		            placeholder={fields.placeOfBirth.placeholder}
		            errMessage={fields.placeOfBirth.errMessage}
		            onChange={this.props.handleInputChange}
		            id="placeOfBirth" />
		        <RadioMultiButton 
		        	fieldsetId="race-select"
					legend={fields.race.legend}
					fieldOpts={fields.race.options}
					fieldName="race"
					required={fields.race.isRequired}
					checkedVal={fields.race.value}
					errMessage={fields.race.errMessage}
					handleMultiChange={this.props.handleInputChange} />
				<RadioMultiButton
					fieldsetId="sex-select" 
					legend={fields.sex.legend}
					fieldOpts={fields.sex.options}
					fieldName="sex"
					required={fields.sex.isRequired}
					checkedVal={fields.sex.value}
					errMessage={fields.sex.errMessage}
					handleMultiChange={this.props.handleInputChange} />
				<PrimaryFormNav 
					prevLabel="Step 8"
					nextLabel="Step 10"
					handlePrevious={this.handlePrevious}
					handleNext={this.handleSubmit}
					options={Object.keys(fields)} />
			</form>
		)
	}
}

export default MinorInfo;


// WEBPACK FOOTER //
// ./src/pages/MinorInfo/MinorInfo.js